import PropTypes from 'prop-types';
import { useQueryData } from 'hook/useQueryData';
import { useGetEntityMarkersQuery } from 'services/entityApi';
import { Chip, Skeleton } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import Icon from '@mui/material/Icon';
import * as React from 'react';

function MarkersList({ entityId, markerIconsConf }) {
  const { data: markers, loading: markersLoading } = useQueryData(
    useGetEntityMarkersQuery,
    entityId
  );

  if (markersLoading) {
    return <Skeleton variant="circular" width={24} height={24} />;
  }
  return (
    <>
      {markers.map((marker) => {
        const markerIcon = markerIconsConf[marker.code];
        return (
          <ListItem key={marker.id}>
            <Chip
              icon={markerIcon && <Icon fontSize="medium">{markerIcon}</Icon>}
              label={marker.name}
            />
          </ListItem>
        );
      })}
    </>
  );
}

MarkersList.propTypes = {
  entityId: PropTypes.number.isRequired,
  markerIconsConf: PropTypes.object
};
export default MarkersList;
